export default "__VITE_ASSET__BFNIZa11__"